import { render, staticRenderFns } from "./SwitchesTop.vue?vue&type=template&id=27fd77c7&scoped=true&"
import script from "./SwitchesTop.vue?vue&type=script&lang=js&"
export * from "./SwitchesTop.vue?vue&type=script&lang=js&"
import style0 from "./SwitchesTop.vue?vue&type=style&index=0&id=27fd77c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fd77c7",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSelect,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27fd77c7')) {
      api.createRecord('27fd77c7', component.options)
    } else {
      api.reload('27fd77c7', component.options)
    }
    module.hot.accept("./SwitchesTop.vue?vue&type=template&id=27fd77c7&scoped=true&", function () {
      api.rerender('27fd77c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/VisaoGeral/internalTemplates/SwitchesTop.vue"
export default component.exports